import request from '@/service/request'
enum Api {
  STATION_DIMSTATION = '/station/dimStation',
  STATION_LIST = '/station/list',
  STATION_EDIT = '/station/edit',
  STATION_DETAIL = '/station/detail',
  STATION_BATCHDISABLE = '/station/batchDisable',
  STATION_EXPORT = '/export/exportAdminStation',
  GET_ORDER_SOURCE = '/orderParcel/source',
  STATION_EXPORTASYNC = '/export/exportAdminStationAsync'
}

export default class siteService {
  /**
   * 导出
   * @param data
   * @returns
   */
  static exportAdminStation(data: Record<string, any>): Promise<any> {
    return request.post(Api.STATION_EXPORT, data, true)
  }
  /**
   * 异步导出
   * @param data
   * @returns
   */
  static exportAdminStationAsync(data: Record<string, any>): Promise<any> {
    return request.post(Api.STATION_EXPORTASYNC, data, true)
  }
  /**
   * 门店模糊搜索
   * @param data
   * @returns
   */
  static dimStation(data: Record<string, any>): Promise<any> {
    return request.post(Api.STATION_DIMSTATION, data)
  }
  
  /**
   * 驿站员工分页
   * @param data
   * @returns
   */
  static pageStaffLike(data: Record<string, any>): Promise<any> {
    return request.post('/staff/pageStaffLike', data)
  }
  /**
   * list
   * @param data
   * @returns
   */
  static list(data: Record<string, any>): Promise<any> {
    return request.post(Api.STATION_LIST, data)
  }
  /**
   * 门店编辑
   * @param data
   * @returns
   */
  static edit(data: Record<string, any>): Promise<any> {
    return request.post(Api.STATION_EDIT, data)
  }
  /**
   * 门店详情
   * @param data
   * @returns
   */
  static detail(data: Record<string, any>): Promise<any> {
    return request.post(Api.STATION_DETAIL, data)
  }
  /**
   * 门店批量禁用
   * @param data
   * @returns
   */
  static batchDisable(data: Record<string, any>): Promise<any> {
    return request.post(Api.STATION_BATCHDISABLE, data)
  }

  /**
   * 寄件入库人员下拉
   * @param data
   * @returns
   */
  static getStaffLike(data: Record<string, any>): Promise<any> {
    return request.post('/staff/staffLike', data)
  }
  /**
   * 获取订单来源
   */
  static getOrderSource(): Promise<any> {
    return request.post(Api.GET_ORDER_SOURCE)
  }
}
